import {Injectable} from 'ng-metadata/core';
import {AbstractRequest} from './abstractRequest';
import {FormBuilderEnums} from '../../../../../../infra/formBuilder/formBuilder.service';
import { MappingTablesCache } from '../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../nddUtils/configurationUtil.service';

@Injectable()
export class CallslipRequest extends AbstractRequest{


    constructor(
        private mappingTablesCache : MappingTablesCache,
        private configurationUtil:ConfigurationUtil
    ) {
        super();
        this.formFields = [
            {
                key: 'select-or-describe',
                name: 'select-or-describe',
                label: '',
                dependOn: {
                    ilsFields : {
                        group1 : ['request-option'],
                        group2 : ['reqinput1','reqinput2','reqinput3']
                    }
                },
                value: 'select-item',
                fieldType: FormBuilderEnums.FIELD_TYPE.INTERNAL,
                uiType: FormBuilderEnums.UI_TYPE.RADIO_BUTTON,
                populator:  {
                    params:     {
                        defaultValue: FormBuilderEnums.FIRST
              
                    }
                },
                options:[
                    {
                        label:'callslip.dropdown.select.item',
                        value:'select-item'
                    },
                    {
                        label:'callsllip.describe.item',
                        value:'describe-item'
                    }
                ],
                events: {
                    onClick: this.onClick.bind(this),
                    params: []
                }

            },
            {
                /* Voyager */
                key: 'request-option',
                name: 'request-option',
                path: 'request-option',
                label: 'callslip.dropdown.select.item',
                mandatory: true,
                dependOn: {key : 'select-or-describe', value: 'select-item'},
                existingPath: 'describe-item/optionid',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'optionid',
                        value:'optiondescription'
                    }
                }
            },
            {
                key: 'reqinput1',
                name: 'reqinput1',
                label: 'callslip.describe.item_1',
                mandatory: true,
                dependOn: {key : 'select-or-describe', value: 'describe-item'},
                existingPath: 'describe-item/reqinput1',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'reqinput2',
                name: 'reqinput2',
                label: 'callslip.describe.item_2',
                mandatory: true,
                dependOn: {key : 'select-or-describe', value: 'describe-item'},
                existingPath: 'describe-item/reqinput2',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                path: 'describe-item'
            },
            {
                key: 'reqinput3',
                name: 'reqinput3',
                label: 'callslip.describe.item_3',
                mandatory: true,
                dependOn: {key : 'select-or-describe', value: 'describe-item'},
                existingPath: 'describe-item/reqinput3',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                path: 'describe-item'
            },
            {
                key: 'locations',
                name: 'pickup_location',
                label: 'callslip.pickup_location',
                path: 'ordered-locations',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'pickuplocationcode',
                        value:'pickuplocationname'
                    }
                }

            },
            {
                key: 'last_interest_date',
                name: 'last_interest_date',
                label: 'hold.last_interest_date',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.DATE,
                uiType: FormBuilderEnums.UI_TYPE.DATE,
                populator:  {
                    params:     {
                        defaultValue: FormBuilderEnums.TODAY, 
                        allow       : FormBuilderEnums.FUTURE_DATES
                    }
                }
            },
            {
                key: 'patron_note_1',
                name: 'patron_note_1',
                label: 'hold.patron_note_1',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            /* group id - internal field */
            {
                key: 'group_id',
                name: 'group_id',
                label: 'group_id',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.INTERNAL,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },
            {
                key: 'ils_db_code',
                name: 'ils_db_code',
                path: 'optional-service-parameters/ils_db_code',
                label: 'hold.ils_db_code',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        defaultValue: FormBuilderEnums.FIRST
                    }
                   
                }
            },
            {
                key: 'holdingrec_id',
                name: 'holdingrec_id',
                path: 'chosen-parameters-map/holdingrec_id',
                label: 'NOT RELEVANT',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },
            /* item level */
            {
                key: 'info-notes',
                name: 'info-notes',
                path: FormBuilderEnums.ROOT,
                label: '',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.MULTI_LABEL,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this)
                }
            },
            {
                key: 'main_location',
                name: 'main_location',
                path: 'drop-downs/main_location',
                label: 'hold.main_location',
                mandatory: true,
                dependOn: {key : 'info-notes', isExists : false},
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        byKey: 'field-name',
                        byValue:'field-values'
                    }
                }
            },
            {
                key: 'item_description',
                name: 'item-description',
                path: 'drop-downs/item_description',
                label: 'hold.item_description',
                mandatory: true,
                dependOn: {key : 'info-notes', isExists : false},
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        byKey: 'field-name',
                        byValue:'field-values'
                    }
                }
            },
            {
                key: 'item_category_name',
                name: 'item-category',
                path: 'drop-downs/item_category',
                label: 'hold.item_category',
                mandatory: false,
                dependOn: {key : 'info-notes', isExists : false},
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        byKey: 'field-name',
                        byValue:'field-values'
                    }
                   
                },
            
            },
            {
                key: 'item_status_name',
                name: 'item-status-name',
                path: 'drop-downs/item_status',
                label: 'hold.item_status',
                mandatory: true,
                dependOn: {key : 'info-notes', isExists : false},
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        byKey: 'field-name',
                        byValue:'field-values'
                    }
                }
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/callslipRequest.ts